<template>
    <div>
        <div class="form-group">
            <input type="text" :class="[brand_error ? 'form-control w100 validate_error_border' : 'form-control w100' ]" v-model="brand_name" placeholder="نام تجاری به فارسی">
            <p v-if="brand_error" class="has_error"> {{ brand_error }}</p>
        </div>
        <div class="form-group">
            <input type="text" :class="[brand_error2 ? 'form-control w100 validate_error_border' : 'form-control w100' ]" v-model="brand_ename" placeholder="نام تجاری به انگلیسی">
            <p v-if="brand_error2" class="has_error"> {{ brand_error2 }}</p>
        </div>
        <div class="form-group">
           <input type="text" :class="[fname_error ? 'form-control w100 validate_error_border' : 'form-control w100' ]" v-model="fname" placeholder="نام کامل مطابق با کارت ملی">
            <p v-if="fname_error" class="has_error"> {{ fname_error }}</p>
        </div>
        <div class="form-group">
            <input type="text" :class="[lname_error ? 'form-control w100 validate_error_border' : 'form-control w100' ]" v-model="lname" placeholder="نام خانوادگی کامل مطابق با کارت ملی">
            <p v-if="lname_error" class="has_error"> {{ lname_error }}</p>
        </div>

        <div class="form-group">
            <div class="row">
              <div class="col-md-6">
                 <select v-on:change="get_city()" v-model="province_id" :class="[province_error ? 'custom-select validate_error_border' : 'custom-select' ]">
                  <option value="" >انتخاب استان</option>
                  <option v-for="province in ProvinceList" v-bind:value="province.id" v-bind:key="province.id">{{ province.name }}</option>
                 </select>
              </div>

             <div class="col-md-6">
                <select v-model="city_id" :class="[city_error ? 'custom-select validate_error_border' : 'custom-select' ]">
                  <option value="" >انتخاب شهر</option>
                  <option v-for="city in CityList" v-bind:value="city.id" v-bind:key="city.id">{{ city.name }}</option>
                </select>
             </div>
          </div>
        </div>

        <div>
            <p v-if="province_error" class="has_error"> {{ province_error }}</p>
            <p v-if="city_error" class="has_error"> {{ city_error }}</p>
        </div>

        <div class="form-group">
            <textarea type="text" :class="[address_error ? 'form-control w100 validate_error_border' : 'form-control w100' ]" v-model="address" placeholder="آدرس فروشگاه به صورت دقیق همراه با پلاک"></textarea>
            <p v-if="address_error" class="has_error"> {{ address_error }}</p>
        </div>

        <div class="form-group">
            <input type="text" :class="[zipcode_error ? 'form-control w100 validate_error_border' : 'form-control w100' ]" v-model="zip_code" placeholder="کد پستی فروشگاه">
            <p v-if="zipcode_error" class="has_error"> {{ zipcode_error }}</p>
        </div>

        <div class="form-group">
            <input type="text" :class="[tel_error ? 'form-control w100 validate_error_border' : 'form-control w100' ]" v-model="tel" placeholder="تلفن ثابت (اختیاری)">
            <p v-if="tel_error" class="has_error"> {{ tel_error }}</p>
        </div>


       <div class="form-check" style="margin-top:15px">
            <span style="padding-left:50px">ثبت نام به صورت : </span>
            <input v-model="account_type"  class="form-check-input" type="radio"  id="personal" value="1">
            <label class="form-check-label register_label" for="personal">شخصی</label>

            <input class="form-check-input" v-model="account_type" type="radio"  id="commercial" value="2">
            <label class="form-check-label register_label" for="Commercial">تجاری</label>
        </div>

         <div class="form-group btn_div" style="margin-top:20px">
             <button class="btn btn-success" v-on:click="send_data()">ثبت و ادامه</button>
        </div>
         <div class="alert alert-warning" id="spinner" v-if="send_form">
            <div class="spinner-border text-warning" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <span style="padding-right:10px;font-size:14px">در حال ارسال اطلاعات ...</span>
        </div>
    </div>
</template>

<script>
import myMinix from '../myMixin';
export default {
    name:"RegisterStep2",
    mixins:[myMinix],
    props:['mobile'],
    data()
    {
        return {
            brand_name:'',
            brand_ename:'',
            brand_error:false,
            brand_error2:false,
            fname_error:false,
            province_error:false,
            lname_error:false,
            city_error:false,
            address_error:false,
            tel_error:false,
            zipcode_error:false,
            fname:'',
            lname:'',
            ProvinceList:[],
            CityList:[],
            province_id:'',
            city_id:'',
            address:'',
            tel:'',
            zip_code:'',
            account_type:1,
            send_form:false
        }
    },
    mounted(){
        this.getProvince();
    },
    methods:{
        send_data:function()
        {
            const check_brand_ename=this.validate_field('نام تجاری',this.brand_ename,'brand_error2',3);
            const check_brand_name=this.validate_field('نام تجاری لاتین',this.brand_name,'brand_error',3);
            const check_fname=this.validate_field('نام',this.fname,'fname_error',3);
            const check_lname=this.validate_field('نام خانوادگی',this.lname,'lname_error',3);
            const check_province_id=this.validate_field('استان',this.province_id,'province_error');
            const check_city_id=this.validate_field('شهر',this.city_id,'city_error');
            const check_address=this.validate_field('آدرس',this.address,'address_error',20);
            const check_zip_code=this.validate_field('کد پستی',this.zip_code,'zipcode_error',10);
            if(check_brand_name && check_fname && check_lname && check_province_id && check_city_id && check_brand_ename && check_address && check_zip_code)
            {
                 if(!this.send_form)
                 {
                    this.$emit('setServerError',false);
                    this.send_form=true;
                    const form_data=new FormData();
                    form_data.append('brand_name',this.brand_name);
                    form_data.append('brand_ename',this.brand_ename);
                    form_data.append('fname',this.fname);
                    form_data.append('lname',this.lname);
                    form_data.append('province_id',this.province_id);
                    form_data.append('city_id',this.city_id);
                    form_data.append('address',this.address);
                    form_data.append('tel',this.tel);
                    form_data.append('zip_code',this.zip_code);
                    form_data.append('mobile',this.mobile);
                    form_data.append('account_type',this.account_type);
                    this.axios.post(this.$siteUrl+'/api/seller/second_step_register',form_data).then(response=>{
                        console.log(response.data);
                        if(response.data.status=='error')
                        {
                            this.send_form=false;
                            this.$emit('setServerError',response.data.message);
                        }
                        else{
                            this.$emit('set_step',response.data.step);
                            this.$emit('set_type',this.account_type);
                        }
                    }).catch(()=>{
                        this.send_form=false;
                        this.$emit('setServerError','خطا در ارسال اطلاعات - مجددا تلاش نمایید');
                    });
                 }
            }
        }
    }
}
</script>

<style>

</style>